import {AnalyticsEventHandler} from "../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";
import {CompetitorPlayerStatsModuleStatsPlayerScrollEvent} from "../../models/analytics/competitor-player-stats-module.stats-player-scroll.event";

export class CompetitorPlayerStatsModuleStatsPlayerScrollEventHandler extends AnalyticsEventHandler {
  type = COMPETITOR_PLAYER_STATS.ACTION_TYPES.statsPlayerScrollHandler;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = CompetitorPlayerStatsModuleStatsPlayerScrollEvent;
  }
}
